/*
 * @Author: your name
 * @Date: 2021-11-27 16:57:06
 * @LastEditTime: 2021-12-14 09:42:06
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /theEventsEditor/projects/events-editor/src/lib/events-editor.service.ts
 */
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EventsEditorService {

  constructor() { }
}
